import { useMutation } from '@tanstack/react-query';
import { deleteContactAddress } from '../../services/fn-api/User';

export const useDeleteContactAddress = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      return deleteContactAddress(id);
    },
  });
};
